import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/retailManage',
  name: 'RetailManage',
  identify: 'retailManage',
  component: LAYOUT,
  redirect: '/retailManage/goodsList',
  meta: {
    icon: 'iconoir:commodity',
    title: '即时零售',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'schedule',
      name: 'Schedule',
      component: () => import('@/views/retailManage/schedule/index.vue'),
      identify: 'schedule',
      meta: {
        title: '排班管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'orderAttri',
      name: 'OrderAttri',
      identify: 'orderAttri',
      component: () => import('@/views/retailManage/orderAttri/index.vue'),
      meta: {
        title: '订单归属管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'orderAttriPage/:pageType/:platOrderNum?',
      name: 'OrderAttriAddPage',
      identify: 'orderAttri',
      component: () => import('@/views/retailManage/orderAttri/add.vue'),
      meta: {
        title: '编辑订单归属',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/retailManage/orderAttri',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
